/**
 * Communication format options used across the application
 */

export interface CommunicationFormatOption {
  key: string;
  value: string;
}

export const COMMUNICATION_FORMAT_OPTIONS: CommunicationFormatOption[] = [
  { key: 'Email', value: 'Email' },
  { key: 'Phone', value: 'Phone' },
  { key: 'VideoCall', value: 'Video Call' },
  { key: 'Chat', value: 'Chat' },
  { key: 'MeetingRoom', value: 'Meeting Room' },
  { key: 'Person', value: 'In Person' },
  { key: 'Group', value: 'Group Meeting' },
];

/**
 * Get display value for a communication format key
 */
export const getCommunicationFormatDisplay = (formatKey: string): string => {
  const option = COMMUNICATION_FORMAT_OPTIONS.find((opt) => opt.key === formatKey);
  return option?.value || formatKey;
};
